import { Alert, Button } from "@mui/material";
import { useActAs } from "@/contexts/ActAsContext";

export const ActingAsBanner = () => {
  const { actAsState, stopActingAs } = useActAs();

  if (!actAsState.isActingAs) return null;

  return (
    <Alert
      severity="warning"
      sx={{
        borderRadius: 0,
        flexShrink: 0,
        position: "relative",
        "& .MuiAlert-message": { flexGrow: 1, textAlign: "center" },
        "& .MuiAlert-icon": { color: "#624E28" },
      }}
      action={
        <Button
          variant="outlined"
          color="warning"
          size="small"
          onClick={stopActingAs}
          sx={{ color: "#624E28", borderColor: "#624E28" }}
        >
          Stop
        </Button>
      }
    >
      You are acting as {actAsState.displayName}
    </Alert>
  );
};
